// Small toast for 404/5xx responses from our own API. Editor-only (see
// index.jsx / AppErrorBoundary mount point) — mirrors AuthRequiredModal's
// window-event bridge but as a lightweight Snackbar instead of a full-screen
// gate, since a server error shouldn't block the whole editor.
import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { Snackbar, Alert } from "@mui/material";
import { SERVER_ERROR_TOAST_EVENT } from "../../utils/serverErrorToast";

const ServerErrorToast = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleServerError = () => setOpen(true);
    window.addEventListener(SERVER_ERROR_TOAST_EVENT, handleServerError);
    return () => window.removeEventListener(SERVER_ERROR_TOAST_EVENT, handleServerError);
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert severity="error" onClose={() => setOpen(false)}>
        {i18n.t("serverErrorToast.message", {
          defaultValue: "Server error — please wait a moment and try again.",
        })}
      </Alert>
    </Snackbar>
  );
};

export default ServerErrorToast;
